/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeverityRatesResponseDto } from './SeverityRatesResponseDto';
import {
    SeverityRatesResponseDtoFromJSON,
    SeverityRatesResponseDtoFromJSONTyped,
    SeverityRatesResponseDtoToJSON,
    SeverityRatesResponseDtoToJSONTyped,
} from './SeverityRatesResponseDto';
import type { InterpolatedSeverityValueDto } from './InterpolatedSeverityValueDto';
import {
    InterpolatedSeverityValueDtoFromJSON,
    InterpolatedSeverityValueDtoFromJSONTyped,
    InterpolatedSeverityValueDtoToJSON,
    InterpolatedSeverityValueDtoToJSONTyped,
} from './InterpolatedSeverityValueDto';

/**
 * 
 * @export
 * @interface InterpolationResultResponseDto
 */
export interface InterpolationResultResponseDto {
    /**
     * 
     * @type {SeverityRatesResponseDto}
     * @memberof InterpolationResultResponseDto
     */
    lowerValue: SeverityRatesResponseDto;
    /**
     * 
     * @type {SeverityRatesResponseDto}
     * @memberof InterpolationResultResponseDto
     */
    upperValue: SeverityRatesResponseDto;
    /**
     * 
     * @type {InterpolatedSeverityValueDto}
     * @memberof InterpolationResultResponseDto
     */
    interpolatedValue: InterpolatedSeverityValueDto;
}

/**
 * Check if a given object implements the InterpolationResultResponseDto interface.
 */
export function instanceOfInterpolationResultResponseDto(value: object): value is InterpolationResultResponseDto {
    if (!('lowerValue' in value) || value['lowerValue'] === undefined) return false;
    if (!('upperValue' in value) || value['upperValue'] === undefined) return false;
    if (!('interpolatedValue' in value) || value['interpolatedValue'] === undefined) return false;
    return true;
}

export function InterpolationResultResponseDtoFromJSON(json: any): InterpolationResultResponseDto {
    return InterpolationResultResponseDtoFromJSONTyped(json, false);
}

export function InterpolationResultResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterpolationResultResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lowerValue': SeverityRatesResponseDtoFromJSON(json['lowerValue']),
        'upperValue': SeverityRatesResponseDtoFromJSON(json['upperValue']),
        'interpolatedValue': InterpolatedSeverityValueDtoFromJSON(json['interpolatedValue']),
    };
}

export function InterpolationResultResponseDtoToJSON(json: any): InterpolationResultResponseDto {
    return InterpolationResultResponseDtoToJSONTyped(json, false);
}

export function InterpolationResultResponseDtoToJSONTyped(value?: InterpolationResultResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lowerValue': SeverityRatesResponseDtoToJSON(value['lowerValue']),
        'upperValue': SeverityRatesResponseDtoToJSON(value['upperValue']),
        'interpolatedValue': InterpolatedSeverityValueDtoToJSON(value['interpolatedValue']),
    };
}

